import { Printer, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const printAs = (mode) => {
  document.body.dataset.print = mode;
  const clear = () => {
    delete document.body.dataset.print;
    window.removeEventListener("afterprint", clear);
  };
  window.addEventListener("afterprint", clear);
  setTimeout(() => window.print(), 50);
};

export const PrintMenu = () => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button data-testid="print-report-button" className="no-print rounded-full bg-[#1F4266] hover:bg-[#122A43]">
        <Printer className="mr-2 h-4 w-4" /> Print / Save as PDF <ChevronDown className="ml-2 h-3.5 w-3.5" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem data-testid="print-all-option" onClick={() => printAs("all")}>Report + workbook</DropdownMenuItem>
      <DropdownMenuItem data-testid="print-report-only-option" onClick={() => printAs("report")}>Report only</DropdownMenuItem>
      <DropdownMenuItem data-testid="print-worksheet-only-option" onClick={() => printAs("worksheet")}>Workbook only</DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
